import {PauseIcon, PlayIcon} from "../Icons";
import React from "react";

export default ({paused, onPlay, onPause}) => {
    if (paused) {
        return <a className="play-pause-button" onClick={onPlay}><PlayIcon /></a>
    }

    return <a className="play-pause-button" onClick={onPause}><PauseIcon /></a>
}
